export default function PlannedGiving() {
  return (
    <section>
      <h2 className="h3 mb-2">Planned giving</h2>
      <p>
        Planned giving details (will include recurring donations and pledges)
      </p>
    </section>
  )
}
